import { useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { Button, Chip, EmptyState } from '@koyomi/ui';
import { AuthCard } from './AuthCard.tsx';
import { useAuthStore } from '../../app/auth-store.ts';
import { api } from '../../lib/api.ts';

export function SelectBusinessPage() {
  const { t } = useTranslation(['auth', 'common']);
  const { businesses, setBusiness, clear } = useAuthStore();
  const navigate = useNavigate();
  const only = businesses.length === 1 ? businesses[0]!.id : null;
  // Um único negócio: seleciona fora do render (efeito) e redireciona.
  useEffect(() => { if (only) setBusiness(only); }, [only, setBusiness]);
  if (only) return <Navigate to="/" replace />;
  const logout = async () => {
    await api('/auth/logout', { method: 'POST', global: true }).catch(() => undefined);
    clear();
  };
  return (
    <AuthCard title={t('auth:selectBusiness.title')} subtitle={businesses.length ? t('auth:selectBusiness.subtitle') : undefined}>
      {businesses.length === 0 ? (
        <EmptyState title={t('common:status.empty')} description={t('auth:selectBusiness.none')} action={<Button onClick={logout}>{t('common:actions.logout')}</Button>} />
      ) : (
        <div className="k-stack">
          {businesses.map((b) => (
            <button key={b.id} type="button" className="k-card k-card--padded k-row" style={{ cursor: 'pointer', textAlign: 'left', justifyContent: 'space-between' }} onClick={() => { setBusiness(b.id); navigate('/', { replace: true }); }}>
              <span>
                <div style={{ fontWeight: 600 }}>{b.name}</div>
                <div className="k-muted" style={{ fontSize: 12 }}>{b.segment}</div>
              </span>
              <Chip tone={b.role === 'ADMIN' ? 'accent' : 'outline'}>{t(`auth:selectBusiness.role.${b.role}`)}</Chip>
            </button>
          ))}
          <Button variant="ghost" onClick={logout}>{t('common:actions.logout')}</Button>
        </div>
      )}
    </AuthCard>
  );
}
